import { Flex, Avatar, Box, Text, Icon } from '@chakra-ui/react';
import { NotificationCard } from '../components/Card';
import { NotificationTime } from '../components/Time';
import OutreachBounced from '@/assets/icons/notification/OutreachBounced';
import { decode } from 'js-base64';
import { NotificationLink } from '../components/NotificationLink';

export const Bounced = ({ notification = {}, onClose = () => {} }) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));

  return (
    <NotificationCard notification={notification}>
      <Flex>
        <Box>
          <Box height="40px" pos="relative">
            <Avatar
              width="36px"
              height="36px"
              borderRadius="8px"
              className="avatar-md"
              name={data?.contact_name}
              src={data?.contact_url}
            />
            <Box pos="absolute" bottom="-24px" left="9px">
              <Icon as={OutreachBounced} width="40px" height="40px" />
            </Box>
          </Box>
        </Box>
        <Box ml="12px">
          <Text>
            <NotificationLink
              to={`/flows/${data?.outreach_id}`}
              label={data.outreach_name}
              onClose={onClose}
              notification={notification}
              data-test-id="flow-link"
            />
            flow has been bounced for
            <NotificationLink
              to={`/candidates/${data.contact_id}`}
              label={data.contact_name}
              onClose={onClose}
              notification={notification}
              data-test-id="contact-link"
            />
          </Text>
          <NotificationTime notification={notification} />
        </Box>
      </Flex>
    </NotificationCard>
  );
};
